import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { Container, StarWrapper } from './FeedbackButton.styles'
import FeedbackModal from './FeedbackModal'

type FeedbackButtonProps = {
  surveyQuestion: string
}

const FeedbackButton: React.FC<FeedbackButtonProps> = ({ surveyQuestion }) => {
  const [showForm, setShowForm] = useState<boolean>(false)

  const handleFeedbackClick = () => {
    setShowForm(!showForm)
  }

  return (
    <>
      <Container onClick={handleFeedbackClick}>
        <p>Feedback</p>
        <StarWrapper>
          {[...Array(5)].map((_, index) => (
            <FontAwesomeIcon
              key={index}
              icon={faStar}
              color="white"
              size="lg"
            />
          ))}
        </StarWrapper>
      </Container>
      {showForm && (
        <FeedbackModal
          surveyQuestion={surveyQuestion}
          setShowForm={setShowForm}
        />
      )}
    </>
  )
}

export default FeedbackButton
